"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createLotto_1 = require("./createLotto");
exports.default = createLotto_1.createLotto;
